import { checkClosestTimeBand } from "../timeBands";
import { Postcode, normalisePostcode } from "../../postcode";
import { OUTER, SECTOR } from "../../../constants/layers";

export const setUpSimulationParcelList = (
  listType, // SECTOR or OUTER
  defaultOverlayDataList = [],
  simulatedDataList = [],
  overlayTimeBand,
  returnType, // List or Total
  manifestLocations = []
) => {
  const list = [];
  let overlayStops = [];
  let allSimStops = [];

  const checkIfManifestLocation = (currentStopLocationCode) =>
    currentStopLocationCode &&
    manifestLocations.find(
      ({ locationCode }) => currentStopLocationCode === locationCode
    );

  if (overlayTimeBand && defaultOverlayDataList.length > 0) {
    overlayTimeBand = checkClosestTimeBand(
      overlayTimeBand,
      defaultOverlayDataList
    );

    defaultOverlayDataList = defaultOverlayDataList.filter(
      (timeBandData, index) => {
        return (
          index <=
          defaultOverlayDataList
            .map((data) => data.timeBand)
            .indexOf(overlayTimeBand)
        );
      }
    );
  }

  if (defaultOverlayDataList.length > 0) {
    overlayStops = defaultOverlayDataList.flatMap(
      (timeBand) => timeBand.overlayStops
    );

    if (returnType === "list") {
      overlayStops.forEach(({ postcode, stopParcels, locationCode }) => {
        const postcodeObj = new Postcode(postcode);
        const area =
          listType === SECTOR ? postcodeObj.toSector() : postcodeObj.toOuter();

        // A space needs to be in front if comparing distracts to stop districts like S61 being placed with S6
        const formattedAreaToCompare = listType === OUTER ? `${area} ` : area;
        const formattedPostcode = normalisePostcode(postcode);
        if (formattedPostcode.startsWith(formattedAreaToCompare)) {
          const areaIndex = list.findIndex((item) => {
            if (listType === SECTOR) {
              return formattedPostcode.startsWith(item.value);
            } else {
              return formattedPostcode.startsWith(`${item.value} `);
            }
          });

          const isManifestLocation = checkIfManifestLocation(locationCode);

          if (areaIndex > -1) {
            list[areaIndex].stops++;
            list[areaIndex].stopParcels += stopParcels;
            if (isManifestLocation) {
              // The first postcode for a sector may not be a manifest location - Which would cause a problem here without the check first
              if (!list[areaIndex].manifestLocationStops[locationCode]) {
                list[areaIndex].manifestLocationStops[locationCode] = {
                  mlStops: 1,
                  mlSimStops: 0,
                };
              } else {
                list[areaIndex].manifestLocationStops[locationCode].mlStops++;
              }
              list[areaIndex].totalMlStops++;
            }
          } else {
            const manifestLocationStops = {};
            if (isManifestLocation)
              manifestLocationStops[locationCode] = {
                mlStops: 1,
                mlSimStops: 0,
              };

            list.push({
              value: area,
              stops: 1,
              stopParcels,
              simStops: 0,
              simStopParcels: 0,
              manifestLocationStops,
              totalMlStops: 0,
              totalMlSimStops: 0,
            });
          }
        }
      });
    }

    if (simulatedDataList !== null) {
      if (overlayTimeBand) {
        simulatedDataList = simulatedDataList.filter((timeBandData, index) => {
          return (
            index <=
            simulatedDataList
              .map((data) => data.timeBand)
              .indexOf(overlayTimeBand)
          );
        });
      }

      allSimStops = simulatedDataList.flatMap(
        (timeBand) => timeBand.overlayStops
      );

      if (returnType === "list") {
        allSimStops.forEach(({ postcode, stopParcels, locationCode }) => {
          const postcodeObj = new Postcode(postcode);
          const area =
            listType === SECTOR
              ? postcodeObj.toSector()
              : postcodeObj.toOuter();

          const formattedAreaToCompare = listType === OUTER ? `${area} ` : area;
          const formattedPostcode = postcodeObj.toPostcode();

          if (normalisePostcode(postcode).startsWith(formattedAreaToCompare)) {
            const areaIndex = list.findIndex((item) => {
              if (listType === SECTOR) {
                return formattedPostcode.startsWith(item.value);
              } else {
                return formattedPostcode.startsWith(`${item.value} `);
              }
            });
            if (areaIndex > -1) {
              list[areaIndex].simStops++;
              list[areaIndex].simStopParcels += stopParcels;

              if (checkIfManifestLocation(locationCode)) {
                list[areaIndex].manifestLocationStops[locationCode]
                  .mlSimStops++;
                list[areaIndex].totalMlSimStops++;
              }
            }
          }
        });
      }
    }

    if (returnType === "list") {
      return list;
    } else if (returnType === "total") {
      return { simTotal: allSimStops.length, total: overlayStops.length };
    } else {
      return "Invalid Return Type";
    }
  }

  return [];
};
